import React, { useEffect } from "react";
import styled from "styled-components";
import { isEmpty } from "lodash";
import { useInView } from "react-intersection-observer";
import { colors } from "@sonder/ui/source/styled/theme";
import { GetUnitTasksTaskData } from "core/queries/GetUnitTasks";
import {
  GetUserRelatedBookingInquiryTasksData,
  GetUserRelatedBookingLeaseInquiryTasksData,
  GetUserRelatedTasksPaginatedData,
} from "core/queries/GetUserRelatedTasks";
import { TaskCell } from "tasks/components/TaskPanel/TaskCell";
import { TaskListLoader } from "tasks/components/TaskPanel/TaskLoader";

const Header = styled.div`
  color: ${colors.gray1};
  font-size: 1rem;
  font-weight: bold;
  line-height: 1.429rem;
  padding-bottom: 0.429rem;
  padding-left: 1.714rem;
  padding-top: 1.714rem;
`;

const LoaderContainer = styled.div`
  padding-left: 1.714rem;
  padding-top: 1rem;
`;

const Placeholder = styled.div`
  color: ${colors.gray1};
  font-size: 1rem;
  line-height: 1.429rem;
  padding-bottom: 1.714rem;
  margin-left: 1.714rem;
  margin-right: 1.714rem;
`;

const StyledIntersectionObserver = styled.div`
  height: 1px;
`;

interface TaskPanelTaskListProps {
  eventName: string;
  header: string;
  loading: boolean;
  onEndReached?(): void;
  placeholder: string;
  tasks: Array<
    | GetUnitTasksTaskData
    | GetUserRelatedBookingInquiryTasksData
    | GetUserRelatedBookingLeaseInquiryTasksData
    | GetUserRelatedTasksPaginatedData
  >;
}
export const TaskPanelTaskList = ({
  eventName,
  header,
  loading,
  onEndReached,
  placeholder,
  tasks,
}: TaskPanelTaskListProps) => {
  const [footerRef, isFooterInView] = useInView();

  useEffect(() => {
    if (isFooterInView && onEndReached) onEndReached();
  }, [isFooterInView]);

  const renderContent = () => {
    if (isEmpty(tasks)) {
      if (loading) return null;

      return <Placeholder>{placeholder}</Placeholder>;
    }

    return tasks.map(task => (
      <TaskCell eventName={eventName} key={task.id} task={task} />
    ));
  };

  return (
    <div>
      <Header>{header}</Header>
      {renderContent()}
      {loading && (
        <LoaderContainer>
          <TaskListLoader />
        </LoaderContainer>
      )}
      <StyledIntersectionObserver ref={footerRef} />
    </div>
  );
};
